export const PDF_BASE_URL = 'https://cdn.sakurafloors.com/assets/pdf';

export const PDF_INSTALL = `${PDF_BASE_URL}/install.pdf`;
export const PDF_MOLDING = `${PDF_BASE_URL}/molding.pdf`;
export const PDF_WARRANTY = `${PDF_BASE_URL}/warranty.pdf`;
